import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_FOOD_MOOD, SET_FOOD_MOOD_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchFoodMood = createAction(FETCH_FOOD_MOOD.CLEANUP)

export const setFoodMoodPageIsDirty = createPayloadAction(
  SET_FOOD_MOOD_PAGE_TO_DIRTY,
)
